import React from 'react';
import {
  TwtPackage3dInclude, TwtPackageFloorplanAddOns,
  TwtPackageFloorplanInclude,
  TwtPackagePhotoAddOns,
  TwtPackagePhotoInclude,
  TwtPackageTimeOfDay
} from '~/tenants/twt/package/common';
import {
  TenantPackageAddOnCheckbox,
  TenantPackageAddOnTemplate,
  TenantPackageIncludes,
} from '~/tenants/common/package';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import TwtMatterportConfig from '~/tenants/twt/performable/matterport/TwtMatterportConfig';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { TwtMatterportFormInputs } from '~/tenants/twt/performable/matterport/TwtMatterportForm';
import Heading from '~/components/layout/Heading';
import Sections from '~/components/layout/Sections';
import PerformableGroupForm, { usePerformableGroup } from '~/components/performable/PerformableGroupForm';
import TwtFloorplanConfig from '~/tenants/twt/performable/floorplan/TwtFloorplanConfig';
import { TwtOrderType } from '~/tenants/twt/model/enums';
import TwtMatterportVideoConfig from '~/tenants/twt/performable/matterport-video/TwtMatterportVideoConfig';
import InputCheckbox from '~/components/input/InputCheckbox';

export default function TwtMatterportTourForm() {
  const group = usePerformableGroup();

  return (
    <>
      <TenantPackageIncludes>
        <TwtPackagePhotoInclude />
        <TwtPackageFloorplanInclude />
        <TwtPackage3dInclude />
      </TenantPackageIncludes>

      <div className="border-theme-separator border-t pt-6 mt-6">
        <Sections>
          <Heading title="Matterport Information" />
          <PerformableGroupForm performable={TwtMatterportConfig}>
            <TwtMatterportFormInputs persona={PersonaType.CUSTOMER} create />
          </PerformableGroupForm>
        </Sections>
      </div>

      <TwtPackageTimeOfDay />

      <TenantPerformableAddOns persona={PersonaType.CUSTOMER}>
        <TwtPackagePhotoAddOns type={TwtOrderType.FOR_SALE_LISTING} />
        <TwtPackageFloorplanAddOns />

        <TenantPackageAddOnTemplate
          htmlFor="matterportvideo"
          title="Matterport video"
          description={TwtMatterportVideoConfig.short}
          image="tenant/twt/matterport/4.png"
          cost="$75.00"
          persona={PersonaType.CUSTOMER}
          enable={
            <InputCheckbox
              id="matterportvideo"
              checked={group.hasPerformable(TwtMatterportVideoConfig)}
              onChange={(checked) => {
                if (group.hasPerformable(TwtMatterportVideoConfig)) {
                  group.removePerformable(TwtMatterportVideoConfig);
                } else {
                  group.addPerformable(TwtMatterportVideoConfig);
                }
              }}
            />
          }
        />

        {group.hasPerformable(TwtMatterportVideoConfig) && (
          <PerformableGroupForm performable={TwtMatterportVideoConfig} />
        )}
      </TenantPerformableAddOns>
    </>
  );
}
